import React from "react";
import errorImage from "../../assets/images/error.png";
import loader from "../../assets/images/loader.gif";
import nodata from "../../assets/images/nodata.png";
import BannerCarousel from "../common/BannerCarousal";
import PagesHeading from "../common/PagesHeading";
import Pagination from "../common/Pagination";
import ProjectFilter from "./ProjectFilter";
import fallbackImg from "../../assets/images/noimg.webp";
const ProjectsList = ({
  projects,
  loading,
  error,
  projectCount,
  handleFilterChange,
  navigateToProjectDetail,
  handlePageChange,
  currentPage,
  topRef,
}) => {
  const noImg = fallbackImg;

  return (
    <>
      <PagesHeading
        title={"Projects"}
        subtitle={`${projectCount} registered projects`}
        description={
          "Explore and discover residential works, interior design, landscaping, urban planning, and more. Get inspired by the global architectural culture at Balarch. Projects created by the most inspiring architects of the moment."
        }
      />
      <BannerCarousel />
      <div
        className="grid grid-cols-1 gap-10 lg:grid-cols-8 mt-20 mb-10"
        ref={topRef}
      >
        <div className="lg:col-span-2">
          <ProjectFilter onFilterChange={handleFilterChange} />
        </div>
        <div className="lg:col-span-6">
          <div className="mb-5">
            <div className="flex  items-center">
              <div className="text-gray-700 text-md font-semibold pl-4">
                {projects.length} REGISTERED PROJECTS
              </div>
            </div>
          </div>
          <hr />
          <div>
            {loading ? (
              <div className="flex justify-center items-center h-screen">
                <img src={loader} alt="Loading" />
              </div>
            ) : error ? (
              <div className="flex justify-center items-center h-screen">
                <img src={errorImage} alt="error" />
              </div>
            ) : projects.length === 0 ? (
              <div className="flex justify-center items-center h-screen">
                <img src={nodata} alt="no data" />
              </div>
            ) : (
              <div className="grid grid-cols-1 gap-10 mt-5 sm:grid-cols-2 lg:grid-cols-3">
                {projects.map((project, index) => (
                  <React.Fragment key={index}>
                    <div
                      className="relative shadow-md cursor-pointer"
                      onClick={() => navigateToProjectDetail(project.ProjectId)}
                    >
                      <img
                        src={project.Image1 || (project.ImageUrls && project.ImageUrls.length > 0 ? project.ImageUrls[0] : noImg)}
                        alt="Project"
                        className="w-full h-40 sm:h-60 object-cover"
                      />
                      <div className="absolute inset-0 flex flex-col gap-2 items-center justify-end opacity-0 hover:opacity-100 transition-opacity duration-300 bg-black bg-opacity-50 text-white p-2">
                        <p className="text-sm sm:text-md font-semibold text-center">
                          {project.ProjectName}
                        </p>
                        <p className="text-xs sm:text-sm">
                          {project?.Country?.countryName || "NA"}
                        </p>
                      </div>
                    </div>
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>

          {projectCount > 0 && (
            <Pagination
              currentPage={currentPage}
              totalItems={projectCount}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ProjectsList;
